import React from 'react'
import './../App.css'
import X46Hull from './X46Hull'
import { Route, Switch, Redirect } from 'react-router-dom'
import X46BowSprit from './X46BowSprit'
import X46HullTreatment from './X46HullTreatment'
import X46Transom from './X46Transom'
import X46Deck from './X46Deck'
import X46Sprayhood from './X46Sprayhood'
import X46Wheel from './X46Wheel'
import X46Mast from './X46Mast'
import X46Interior from './X46Interior'
import X46Galley from './X46Galley'
import X46Fabric from './X46Fabric'
import X46Saloon from './X46Saloon'
import X46OwnersCabin from './X46OwnersCabin'
import X46AftCabin from './X46AftCabin'
import Logo from './x46-logo.svg'
import X46Summary from './X46Summary'
import X46BathingPlatform from './X46BathingPlatform'

import hullColor11 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x light grey RAL 7035 waterliness.jpg'
import hullColor12 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x black grey RAL 702 waterlines.jpg'
import hullColor13 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x dark blue RAL 5011 waterlines.jpg'
import hullColor14 from '../assets/hullColors/Hull colour - light grey RAL 7035 & 3 x pure white RAL 9010 waterlines.jpg'
import hullColor15 from '../assets/hullColors/Hull colour - black grey RAL 7021 & 3 x pure white RAL 9010 waterlines.jpg'

import fabric1 from '../assets/fabrics/JustFleckless–01Nature.jpg'
import fabric2 from '../assets/fabrics/JustFleckless–05Camel.jpg'
import fabric3 from '../assets/fabrics/JustFleckless–10Navy.jpg'
import fabric4 from '../assets/fabrics/JustFleckless–403Bambus.jpg'
import fabric5 from '../assets/fabrics/JustFleckless–710MoonGrey.jpg'
import fabric6 from '../assets/fabrics/JustFleckless–750OliveGrey.jpg'
import fabric7 from '../assets/fabrics/AlsaceBlue.jpg'
import fabric8 from '../assets/fabrics/AlsaceIvory.jpg'
import fabric9 from '../assets/fabrics/AlsaceSand.jpg'
import fabric10 from '../assets/fabrics/Nubilux709Argent.jpg'

import galley1 from '../assets/galleyColors/camoan_white_corian.jpg'
import galley2 from '../assets/galleyColors/black_quartz_corian.jpg'

import veneer1 from '../assets/interiorColors/nordic_oak.jpg'
import veneer2 from '../assets/interiorColors/teak.jpg'

import laminate1 from '../assets/interiorColors/teak_without_koto.jpg'
import laminate2 from '../assets/interiorColors/walnut.jpg'
import laminate3 from '../assets/interiorColors/teak_with_koto.jpg'

import sprayhood1 from '../assets/sprayhoodColors/without.jpg'
import sprayhood2 from '../assets/sprayhoodColors/Dark grey.jpg'
import sprayhood3 from '../assets/sprayhoodColors/Taupe.jpg'
import sprayhood4 from '../assets/sprayhoodColors/Captains blue.jpg'
import sprayhood5 from '../assets/sprayhoodColors/Silver grey.jpg'

import ConfiguratorContainer from '../ConfiguratorContainer'
import { withTranslation } from 'react-i18next'

class X46Container extends ConfiguratorContainer {
  constructor (props) {
    super(props)

    this.logo = Logo
    this.logoLink = 'https://www.x-yachts.com/en/yachts/x/x4-6/'

    this.HullColourOptions = [
      {
        value: 1,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Light Grey (RAL 7035) integrated Gelcoat Water Lines'
        ),
        preview: hullColor11
      },
      {
        value: 2,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Black Grey (RAL 7021) integrated Gelcoat Water Lines'
        ),
        preview: hullColor12
      },
      {
        value: 3,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Dark Blue (RAL 5011) integrated Gelcoat Water Lines'
        ),
        preview: hullColor13
      },
      {
        value: 4,
        label: this.props.t('Light Grey'),
        description: this.props.t(
          '(RAL 7035) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'
        ),
        preview: hullColor14
      },
      {
        value: 5,
        label: this.props.t('Black Grey'),
        description: this.props.t(
          '(RAL 7021) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'
        ),
        preview: hullColor15
      }
    ]

    this.BowSpritOptions = [
      {
        value: 1,
        label: this.props.t('Standard GRP cowl'),
        description: this.props.t('(without bowsprit)')
      },
      {
        value: 2,
        label: this.props.t('Painted carbon fibre bow sprit'),
        description: this.props.t('(will match hull color)')
      },
      { value: 3, label: this.props.t('Clear coated carbon fibre bowsprit') }
    ]

    this.HullTreatmentOptions = [
      { value: 1, label: this.props.t('White') },
      { value: 2, label: this.props.t('Black') },
      { value: 3, label: this.props.t('Copper') }
    ]

    this.DeckOptions = [
      { value: 1, label: this.props.t('Genuine teak with black caulkings') },
      { value: 2, label: this.props.t('Flexiteek with grey stripes') }
    ]

    this.SprayhoodVersionOptions = [
      { value: 1, label: this.props.t('Short - 2-framed version') },
      { value: 2, label: this.props.t('Long - 3-framed version') }
    ]

    this.SprayhoodOptions = [
      { value: 1, label: this.props.t('Without'), thumbnail: sprayhood1 },
      { value: 2, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
      { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
      { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
      { value: 5, label: this.props.t('Silver grey'), thumbnail: sprayhood5 }
    ]

    this.BoomCoverOptions = this.SprayhoodOptions

    this.WheelOptions = [
      { value: 1, label: this.props.t('Steel wheel') },
      { value: 2, label: this.props.t('Composite wheel black') },
      { value: 3, label: this.props.t('Composite wheel white') }
    ]

    this.MastAndBoomOptions = [
      { value: 1, label: this.props.t('Aluminium') },
      { value: 2, label: this.props.t('Clear coated carbon') },
      { value: 3, label: this.props.t('White painted carbon') },
      { value: 4, label: this.props.t('Black painted carbon') }
    ]

    this.VeneerOptions = [
      {
        value: 1,
        label: this.props.t('Nordic oak (standard)'),
        thumbnail: veneer1
      },
      {
        value: 2,
        label: this.props.t('Modern teak (optional)'),
        thumbnail: veneer2
      }
    ]

    this.FloorboardOptions = [
      {
        value: 1,
        label: this.props.t('Teak laminate (standard)'),
        thumbnail: laminate1
      },
      {
        value: 2,
        label: this.props.t('Walnut laminate (optional)'),
        thumbnail: laminate2
      },
      {
        value: 3,
        label: this.props.t('Teak with inlay stripes / holly (optional)'),
        thumbnail: laminate3
      }
    ]

    this.WorktopOptions = [
      {
        value: 1,
        label: this.props.t('Worktop in Camoan white Corian'),
        thumbnail: galley1
      },
      {
        value: 2,
        label: this.props.t('Worktop in black quartz Corian'),
        thumbnail: galley2
      }
    ]

    this.FabricOptions = [
      {
        value: 1,
        label: this.props.t('Just Fleckless – 01 Nature'),
        thumbnail: fabric1
      },
      {
        value: 2,
        label: this.props.t('Just Fleckless – 05 Camel'),
        thumbnail: fabric2
      },
      {
        value: 3,
        label: this.props.t('Just Fleckless – 10 Navy'),
        thumbnail: fabric3
      },
      {
        value: 4,
        label: this.props.t('Just Fleckless – 403 Bambus'),
        thumbnail: fabric4
      },
      {
        value: 5,
        label: this.props.t('Just Fleckless – 710 Moon Grey'),
        thumbnail: fabric5
      },
      {
        value: 6,
        label: this.props.t('Just Fleckless – 750 Olive Grey'),
        thumbnail: fabric6
      },
      { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
      { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
      { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
      {
        value: 10,
        label: this.props.t('Nubilux 709 Argent'),
        thumbnail: fabric10
      }
    ]

    this.SplitBerthOptions = [
      {
        value: 1,
        label: this.props.t('Double berth'),
        description: this.props.t(' (standard) ')
      },
      {
        value: 2,
        label: this.props.t('Split berth'),
        description: this.props.t('(optional)')
      }
    ]

    const defaultHullColour = this.HullColourOptions[0]
    const defaultTransomColor = this.getTransomColorByHullColourValue(
      defaultHullColour.value
    )

    this.state = Object.assign(this.state, {
      boat: 'X46',
      exterior: {
        HullColour: defaultHullColour,
        BowSprit: this.BowSpritOptions[0],
        HullTreatment: this.HullTreatmentOptions[0],
        Deck: this.DeckOptions[0],
        TeakOnSideDecks: { value: 1, label: 'false' },
        TeakOnCoachroof: { value: 1, label: 'false' },
        BathingPlatform: { value: 1, label: 'false' },
        TeakOnBathingPlatform: { value: 1, label: 'false' },
        SprayHoodVersion: this.SprayhoodVersionOptions[0],
        SprayHood: this.SprayhoodOptions[0],
        Wheel: this.WheelOptions[0],
        MastAndBoom: this.MastAndBoomOptions[0],
        BoomCover: this.BoomCoverOptions[0]
      },
      transom: {
        Name: {
          verticalOffset: 0,
          color: defaultTransomColor,
          value: 'My yacht',
          font: this.fontOptions[0],
          size: this.sizeOptions[2],
          horizontalOffset: 0
        },
        Port: {
          verticalOffset: 350,
          color: defaultTransomColor,
          value: 'Port',
          font: this.fontOptions[0],
          size: this.sizeOptions[1],
          horizontalOffset: 0
        }
      },
      interior: {
        Veneer: this.VeneerOptions[0],
        Floorboard: this.FloorboardOptions[0],
        Worktop: this.WorktopOptions[0],
        Fabric: this.FabricOptions[0],
        CupboardsSaloon: { value: 1, label: 'false' },
        CupboardsOwnersCabin: { value: 1, label: 'false' },
        SplitBerth: this.SplitBerthOptions[0],
        Backrest: { value: 1, label: 'false' },
        TableBox: { value: 1, label: 'false' },
        Pouffes: { value: 1, label: 'false' },
        FabricOwnersCabin: this.FabricOptions[0],
        FabricAftCabin: this.FabricOptions[0],
        AftCabinShelving: { value: 1, label: 'false' }
      }
    })

    this.steps = [
      { name: this.props.t('Hull colourways'), url: '/x46/hull' },
      { name: this.props.t('Bowsprit'), url: '/x46/bowsprit' },
      { name: this.props.t('Hull treatment'), url: '/x46/hulltreatment' },
      { name: this.props.t('Deck'), url: '/x46/deck' },
      { name: this.props.t('Bathing platform'), url: '/x46/bathingplatform' },
      { name: this.props.t('Boat name'), url: '/x46/transom' },
      { name: this.props.t('Mast and boom'), url: '/x46/mast' },
      { name: this.props.t('Wheels'), url: '/x46/wheel' },
      { name: this.props.t('Sprayhood & Boom Cover'), url: '/x46/sprayhood' },

      { name: this.props.t('Interior surfaces'), url: '/x46/surfaces' },
      { name: this.props.t('Saloon furniture'), url: '/x46/saloon' },
      { name: this.props.t('Interior Fabric'), url: '/x46/fabric' },
      { name: this.props.t('Galley'), url: '/x46/galley' },
      { name: this.props.t("Owner's cabin"), url: '/x46/ownerscabin' },
      { name: this.props.t('Aft cabins'), url: '/x46/aftcabin' },

      { name: this.props.t('Summary'), url: '/x46/summary' }
    ]

    this.handleHullConfigurationChange =
      this.handleHullConfigurationChange.bind(this)
  }

  handleHullConfigurationChange (newConfiguration) {
    let transom = this.state.transom
    const transomColor = this.getTransomColorByHullColourValue(
      newConfiguration.HullColour.value
    )
    transom.Name.color = transomColor
    transom.Port.color = transomColor

    super.handleTransomChange(transom)
    super.handleExteriorConfigurationChange(newConfiguration)
  }

  getTransomColorByHullColourValue (hullColourValue) {
    if (hullColourValue === 4 || hullColourValue === 5) {
      return this.colorOptions[1]
    }

    return this.colorOptions[4]
  }

  generateCode () {
    let data = []
    data.push('x46')

    data.push([])
    let exterior = this.state.exterior
    for (const key in exterior) {
      if (exterior.hasOwnProperty(key)) {
        let element = exterior[key].value
        data[data.length - 1].push(element)
      }
    }

    data.push([])
    data[data.length - 1].push([])
    data[data.length - 1].push([])

    let transom = this.state.transom
    data[data.length - 1][0].push(transom.Name.value)
    data[data.length - 1][0].push(transom.Name.font.value)
    data[data.length - 1][0].push(transom.Name.size.value)
    data[data.length - 1][0].push(transom.Name.color.value)
    data[data.length - 1][0].push(transom.Name.horizontalOffset)
    data[data.length - 1][0].push(transom.Name.verticalOffset)

    data[data.length - 1][1].push(transom.Port.value)
    data[data.length - 1][1].push(transom.Port.font.value)
    data[data.length - 1][1].push(transom.Port.size.value)
    data[data.length - 1][1].push(transom.Port.color.value)
    data[data.length - 1][1].push(transom.Port.horizontalOffset)
    data[data.length - 1][1].push(transom.Port.verticalOffset)

    data.push([])
    let interior = this.state.interior
    for (const key in interior) {
      if (interior.hasOwnProperty(key)) {
        let element = interior[key].value
        data[data.length - 1].push(element)
      }
    }

    var json = JSON.stringify(data)
    return btoa(json)
  }

  parseCode (code) {
    let json = JSON.parse(atob(code))

    if (json[0] !== 'x46') {
      return
    }

    let exterior = this.state.exterior
    exterior.HullColour =
      this.HullColourOptions.find(v => v.value === json[1][0]) ||
      this.HullColourOptions[0]
    exterior.BowSprit =
      this.BowSpritOptions.find(v => v.value === json[1][1]) ||
      this.BowSpritOptions[0]
    exterior.HullTreatment =
      this.HullTreatmentOptions.find(v => v.value === json[1][2]) ||
      this.HullTreatmentOptions[0]
    exterior.Deck =
      this.DeckOptions.find(v => v.value === json[1][3]) || this.DeckOptions[0]
    exterior.TeakOnSideDecks = { value: +json[1][4] || 1, label: '' }
    exterior.TeakOnCoachroof = { value: +json[1][5] || 1, label: '' }
    exterior.BathingPlatform = { value: +json[1][6] || 1, label: '' }
    exterior.TeakOnBathingPlatform = { value: +json[1][7] || 1, label: '' }
    exterior.SprayHoodVersion =
      this.SprayhoodVersionOptions.find(v => v.value === json[1][8]) ||
      this.SprayhoodVersionOptions[0]
    exterior.SprayHood =
      this.SprayhoodOptions.find(v => v.value === json[1][9]) ||
      this.SprayhoodOptions[0]
    exterior.Wheel =
      this.WheelOptions.find(v => v.value === json[1][10]) ||
      this.WheelOptions[0]
    exterior.MastAndBoom =
      this.MastAndBoomOptions.find(v => v.value === json[1][11]) ||
      this.MastAndBoomOptions[0]
    exterior.BoomCover =
      this.BoomCoverOptions.find(v => v.value === json[1][12]) ||
      this.BoomCoverOptions[0]

    let transom = this.state.transom
    transom.Name.value = json[2][0][0] || ''
    transom.Name.font =
      this.fontOptions.find(v => v.value === json[2][0][1]) ||
      this.fontOptions[0]
    transom.Name.size =
      this.sizeOptions.find(v => v.value === json[2][0][2]) ||
      this.sizeOptions[0]
    transom.Name.color =
      this.colorOptions.find(v => v.value === json[2][0][3]) ||
      this.colorOptions[0]
    transom.Name.horizontalOffset = +json[2][0][4] || 1
    transom.Name.verticalOffset = +json[2][0][5] || 1

    transom.Port.value = json[2][1][0] || ''
    transom.Port.font =
      this.fontOptions.find(v => v.value === json[2][1][1]) ||
      this.fontOptions[0]
    transom.Port.size =
      this.sizeOptions.find(v => v.value === json[2][1][2]) ||
      this.sizeOptions[0]
    transom.Port.color =
      this.colorOptions.find(v => v.value === json[2][1][3]) ||
      this.colorOptions[0]
    transom.Port.horizontalOffset = +json[2][1][4] || 1
    transom.Port.verticalOffset = +json[2][1][5] || 1

    let interior = this.state.interior
    interior.Veneer =
      this.VeneerOptions.find(v => v.value === json[3][0]) ||
      this.VeneerOptions[0]
    interior.Floorboard =
      this.FloorboardOptions.find(v => v.value === json[3][1]) ||
      this.FloorboardOptions[0]
    interior.Worktop =
      this.WorktopOptions.find(v => v.value === json[3][2]) ||
      this.WorktopOptions[0]
    interior.Fabric =
      this.FabricOptions.find(v => v.value === json[3][3]) ||
      this.FabricOptions[0]
    interior.Pouffes = { value: +json[3][4] || 1, label: '' }
    interior.CupboardsSaloon = { value: +json[3][5] || 1, label: '' }
    interior.CupboardsOwnersCabin = { value: +json[3][6] || 1, label: '' }
    interior.SplitBerth =
      this.SplitBerthOptions.find(v => v.value === json[3][7]) ||
      this.SplitBerthOptions[0]
    interior.Backrest = { value: +json[3][8] || 1, label: '' }
    interior.TableBox = { value: +json[3][9] || 1, label: '' }
    interior.FabricOwnersCabin =
      this.FabricOptions.find(v => v.value === json[3][10]) ||
      this.FabricOptions[0]
    interior.FabricAftCabin =
      this.FabricOptions.find(v => v.value === json[3][11]) ||
      this.FabricOptions[0]
    interior.AftCabinShelving = { value: +json[3][12] || 1, label: '' }

    this.setState(this.state)
  }

  renderSteps () {
    return (
      <Switch location={this.props.location}>
        <Route exact path='/x46' render={() => <Redirect to='/x46/hull' />} />

        <Route
          path='/x46/hull'
          render={props => (
            <X46Hull
              {...props}
              onChange={this.handleHullConfigurationChange}
              onCodeSubmitted={this.parseCode}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullColourOptions={this.HullColourOptions}
            />
          )}
        />
        <Route
          path='/x46/bowsprit'
          render={props => (
            <X46BowSprit
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              bowSpritOptions={this.BowSpritOptions}
            />
          )}
        />
        <Route
          path='/x46/hulltreatment'
          render={props => (
            <X46HullTreatment
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullTreatmentOptions={this.HullTreatmentOptions}
            />
          )}
        />
        <Route
          path='/x46/transom'
          render={props => (
            <X46Transom
              {...props}
              onChange={this.handleTransomChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              fontOptions={this.fontOptions}
              sizeOptions={this.sizeOptions}
              colorOptions={this.colorOptions}
            />
          )}
        />
        <Route
          path='/x46/deck'
          render={props => (
            <X46Deck
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              deckOptions={this.DeckOptions}
            />
          )}
        />
        <Route
          path='/x46/bathingplatform'
          render={props => (
            <X46BathingPlatform
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              transom={this.state.transom}
              configuration={this.state.exterior}
            />
          )}
        />
        <Route
          path='/x46/sprayhood'
          render={props => (
            <X46Sprayhood
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              sprayhoodVersionOptions={this.SprayhoodVersionOptions}
              sprayhoodOptions={this.SprayhoodOptions}
              boomCoverOptions={this.BoomCoverOptions}
            />
          )}
        />
        <Route
          path='/x46/wheel'
          render={props => (
            <X46Wheel
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              wheelOptions={this.WheelOptions}
            />
          )}
        />
        <Route
          path='/x46/mast'
          render={props => (
            <X46Mast
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              mastAndBoomOptions={this.MastAndBoomOptions}
            />
          )}
        />

        <Route
          path='/x46/surfaces'
          render={props => (
            <X46Interior
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              veneerOptions={this.VeneerOptions}
              floorboardOptions={this.FloorboardOptions}
            />
          )}
        />
        <Route
          path='/x46/saloon'
          render={props => (
            <X46Saloon
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
            />
          )}
        />
        <Route
          path='/x46/fabric'
          render={props => (
            <X46Fabric
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              fabricOptions={this.FabricOptions}
            />
          )}
        />
        <Route
          path='/x46/galley'
          render={props => (
            <X46Galley
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              worktopOptions={this.WorktopOptions}
            />
          )}
        />
        <Route
          path='/x46/aftcabin'
          render={props => (
            <X46AftCabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              fabricOptions={this.FabricOptions}
              configuration={this.state.interior}
              aftCabinOptions={this.SplitBerthOptions}
            />
          )}
        />
        <Route
          path='/x46/ownerscabin'
          render={props => (
            <X46OwnersCabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              fabricOptions={this.FabricOptions}
              configuration={this.state.interior}
            />
          )}
        />

        <Route
          path='/x46/summary'
          render={props => (
            <X46Summary
              {...props}
              country={this.state.country}
              countries={this.state.countries}
              code={this.generateCode()}
              configuration={{
                exterior: this.state.exterior,
                interior: this.state.interior,
                transom: this.state.transom
              }}
            />
          )}
        />
      </Switch>
    )
  }
}

export default withTranslation()(X46Container)



// WEBPACK FOOTER //
// ./src/X46/X46Container.js